export default class PriceComparisonReportActions {

    static NEW_DATA = 'NEW_DATA';
    static RESET_DATA = 'RESET_DATA';
    static PROCESS_DATA = 'PROCESS_DATA';
    static GET_HELPER_PRICECOMPARISONREPORT = 'GET_HELPER_PRICECOMPARISONREPORT';
    static GET_DATA = 'GET_DATA';
    static ERROR_DATA='ERROR_DATA';
    static SET_DATA_SELLING = 'SET_DATA_SELLING';
    static SET_DATA_PURCHASING = 'SET_DATA_PURCHASING';
    static LOADING_DETAILS = 'LOADING_DETAILS';
    static LOADED_DETAILS = 'LOADED_DETAILS';
    static PRINT_PRICECOMPARISONREPORT = 'PRINT_PRICECOMPARISONREPORT';
    static PRINT_PRICECOMPARISON_SELLING = 'PRINT_PRICECOMPARISON_SELLING';
    static PRINT_PRICECOMPARISON_PURCHASING = 'PRINT_PRICECOMPARISON_PURCHASING';
    static BEFORE_PRINT_PRICECOMPARISON_SELLING = 'BEFORE_PRINT_PRICECOMPARISON_SELLING';
    static BEFORE_PRINT_PRICECOMPARISON_PURCHASING = 'BEFORE_PRINT_PRICECOMPARISON_PURCHASING';

    static loadingDetails(){
      return {
        type:PriceComparisonReportActions.LOADING_DETAILS
      }
    }
    static process(){
      return {
        type:PriceComparisonReportActions.PROCESS_DATA
      }
    }

    static error(error){
      return {
        type:  PriceComparisonReportActions.ERROR_DATA,
        payload: error
      };
    }

    static loadedDetails(data){
      return {
        type:PriceComparisonReportActions.LOADED_DETAILS,
        payload:data,
      }
    }

    static new(){
      return {
        type:PriceComparisonReportActions.NEW_DATA
      }
    }
    static process(){
      return {
        type:PriceComparisonReportActions.GET_DATA
      }
    }

    static setDataSelling(dataSelling){
      return {
        type:PriceComparisonReportActions.SET_DATA_SELLING,
        payload:dataSelling
      }
    }

    static setDataPurchasing(dataPurchasing){
      return {
        type:PriceComparisonReportActions.SET_DATA_PURCHASING,
        payload:dataPurchasing
      }
    }

    static reset(){
      return {
        type:PriceComparisonReportActions.RESET_DATA
      }
    }
    static helper(data){
      return {
        type:PriceComparisonReportActions.GET_HELPER_PRICECOMPARISONREPORT,
        payload:data
      }
    }

    static beforePrint(){
      return {
        type: PriceComparisonReportActions.BEFORE_PRINT_PRICECOMPARISONREPORT,
      };
    }

    static beforePrintSelling(){
      return {
        type: PriceComparisonReportActions.BEFORE_PRINT_PRICECOMPARISON_SELLING,
      };
    }

    static beforePrintPurchasing(){

      return {
        type: PriceComparisonReportActions.BEFORE_PRINT_PRICECOMPARISON_PURCHASING,
      };
    }

    static printSelling(printSelling){
      return {
        type: PriceComparisonReportActions.PRINT_PRICECOMPARISON_SELLING,
        payload: printSelling
      };
    }
    static printPurchasing(printPurchasing){
      return {
        type: PriceComparisonReportActions.PRINT_PRICECOMPARISON_PURCHASING,
        payload: printPurchasing
      };
    }
    
  }
  
  